import { render, staticRenderFns } from "./scoreConversion.vue?vue&type=template&id=70b1cb88&"
import script from "./scoreConversion.vue?vue&type=script&lang=js&"
export * from "./scoreConversion.vue?vue&type=script&lang=js&"
import style0 from "./scoreConversion.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports